import { useEffect, useState } from "react";

const CustomCheckBox = ({
  isSelected,
  name,
  onChange,
  id,
}: {
  isSelected: boolean;
  name: string;
  onChange: (arg1: any, arg2: number) => void;
  id: number;
}) => {
  const [isChecked, setIsChecked] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (isSelected) {
      setIsChecked(isSelected);
    }
  }, [isSelected]);

  return (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        defaultChecked={isChecked}
        onClick={(e) => onChange(e, id)} // Please keep this as onClick, don't change to onChange
      />
      <label className="form-check-label">{name}</label>
    </div>
  );
};

export default CustomCheckBox;
